import React from 'react';
import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button';
import { useEffect } from 'react'
import { Separator } from '@/components/ui/separator';


function Colofon() {

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className='mx-auto max-w-prose my-12 font-gotham text-medium text-start px-8'>
        {/*       <tag className="font-gotham text-background bg-black rounded-full px-4 py-2 text-bold">Jaar 1</tag> */}
        <h1 className='my-6'>Privacy Statement</h1>
        <p className='my-6'>
        Deze website maakt gebruik van Vercel Analytics om inzicht te krijgen in het gebruik van de site. Vercel Analytics werkt zonder cookies en verzamelt geen persoonlijke identificerende gegevens. Het systeem registreert uitsluitend geanonimiseerde gegevens, zoals paginaweergaven, apparaat- en browsertype, en algemene prestatiestatistieken. Deze informatie wordt gebruikt om de werking en gebruikservaring van de website te verbeteren.
<br></br><br></br>
Verder worden er geen persoonsgegevens verzameld, opgeslagen of gedeeld via deze website. We gebruiken geen tracking cookies, formulieren, marketingtools of externe trackers.
<br></br><br></br>
De website wordt gehost door Vercel, waar standaard serverlogs voor beveiligings- en foutopsporingsdoeleinden kunnen worden opgeslagen. Deze logs bevatten onder andere IP-adressen, maar worden automatisch geanonimiseerd en niet gebruikt om bezoekers te identificeren.
<br></br><br></br>
Als je vragen hebt over deze privacyverklaring, kun je contact opnemen via:<br></br><br></br>

Cypher Studio<br></br>
hello@cypherstudio.org
        </p>

      </div>



    </>
  );
}

export default Colofon;